module.exports = __webpack_public_path__ + "static/media/icon2.1c1d28c8.png";